__turbopack_context__.v({
  "caption": "gallery-marquee-module__HoWp2W__caption",
  "close": "gallery-marquee-module__HoWp2W__close",
  "dialog": "gallery-marquee-module__HoWp2W__dialog",
  "next": "gallery-marquee-module__HoWp2W__next",
  "pause": "gallery-marquee-module__HoWp2W__pause",
  "photo": "gallery-marquee-module__HoWp2W__photo",
  "previous": "gallery-marquee-module__HoWp2W__previous",
  "section": "gallery-marquee-module__HoWp2W__section",
  "studioMarquee": "gallery-marquee-module__HoWp2W__studioMarquee",
  "thumbnail": "gallery-marquee-module__HoWp2W__thumbnail",
  "track": "gallery-marquee-module__HoWp2W__track",
  "viewport": "gallery-marquee-module__HoWp2W__viewport",
});
